import { useNavigate } from 'react-router-dom';
import PageWrapper from '../../components/PageWrapper';
import { IoMdAdd } from 'react-icons/io';
import SupplierPage from './components/SupplierPage';
const Suppliers = () => {
  const navigate = useNavigate();
  return (
    <PageWrapper>
      <div className="w-full flex flex-col gap-10 py-6">
        {/* Header */}
        <div className="w-full flex flex-col md:flex-row md:items-center justify-between gap-4 md:gap-0">
          {/* Text Content */}
          <div>
            <h1 className="text-[#0226BE] text-[24px] md:text-[28px] font-[500] mb-1 flex-1 md:flex-none flex items-center justify">
              Suppliers
            </h1>
            <p className="text-[#666] text-[13px] md:text-[14px] font-[400]">
              Manage your supplier accounts, contact details, and activity all
              in one place.
            </p>
          </div>

          {/* Buttons Container */}
          <div className="flex flex-wrap items-center gap-3">
            <button
              className="flex-shrink-0 bg-[#0226BE] text-white px-5 py-3 text-[14px] font-[500] rounded-md hover:bg-[#021ea8] transition-colors flex items-center gap-2 whitespace-nowrap"
              onClick={() => {
                navigate('/suppliers/create-new-supplier');
              }}
            >
              <IoMdAdd size={20} />
              Create Supplier
            </button>
          </div>
        </div>
        <SupplierPage />
      </div>
    </PageWrapper>
  );
};

export default Suppliers;
